export default __webpack_public_path__ + "static/media/Tanduri.ca92ae60.png";